import React from 'react'
import PropTypes from 'prop-types'

import Modal from 'components/_new/modal/Modal/Modal'

import Buttons from './Buttons/Buttons'


const DialogModal = ({ children, title, text, leftButton, rightButton, dataTestId, onClose }) => (
  <Modal
    title={title}
    text={text}
    dataTestId={dataTestId}
    footerNode={<Buttons leftButton={leftButton} rightButton={rightButton} />}
    onClose={onClose}
  >
    {children}
  </Modal>
)

DialogModal.propTypes = {
  ...Modal.propTypes,
  leftButton: PropTypes.object,
  rightButton: PropTypes.object,
}


export default DialogModal
